import React, { useEffect } from 'react';

const RuleChaining: React.FC = () => {
    useEffect(() => {
        import('../rulechainingphaser/RCGame');

    }, []);

    return (
        <div
            id="game-container"
            style={{
                position: 'fixed',
                top: '1vh',       // etwas kleiner als ganz, kann man gerne auf vollbild ändern, nur gerade noch übersichtlicher!
                left: '1vw',      // etwas kleiner als ganz
                width: '98vw',    // etwas kleiner als ganz
                height: '98vh',   // etwas kleiner als ganz
                padding: 0,
                backgroundColor: '#000', // schwarzer Rand sichtbar
                zIndex: 9999, //überdeckt alles andere
                overflow: 'hidden',
                borderRadius: '8px',     // ganz leicht abgerundete ecken, kann man gerne entfernen
            }}
        />
    );

};

export default RuleChaining;
